import React, { Suspense } from "react";
import { Layout, Spin } from "antd";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory as createHistory } from "history";
import Header from "../Header";
import routes from "../../routes";
import "./styles.css";

const history = createHistory();
const { Footer } = Layout;

const Loading = (
  <div style={{ textAlign: "center", marginTop: "10%" }}>
    <Spin size="large" />
  </div>
);

interface IMainState {}

interface IMainProps {}

class Main extends React.Component<IMainProps, IMainState> {
  state: IMainState = {};

  render() {
    return (
      <Router history={history}>
        <Layout style={{ minHeight: "100vh" }}>
          <Header history={history} />
          <Layout style={{ marginTop: 48 }}>
            <Suspense fallback={Loading}>
              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      render={(props) => <route.component {...props} />}
                    />
                  ) : null;
                })}
                <Redirect from="/" to="/" />
              </Switch>
            </Suspense>
          </Layout>
          <Footer className="ketrics-footer">
            Powered by{" "}
            <img src="/img/logo.png" alt="Ketrics" width="60" style={{ marginBottom: 3 }} />
            {" | "}
            Copyright ©️ 2021
          </Footer>
        </Layout>
      </Router>
    );
  }
}

export default Main;
